import {EmptyStatus} from 'platform/components';
import {Show} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {useGetWorkshopInterestQuery} from '@dms/api/workshop';
import i18n from '@dms/i18n';
import {OwnershipSection, Section} from '@dms/shared';

interface OwnershipProps {
  interestId: string;
}

export function Ownership(props: OwnershipProps) {
  const {data: workshopInterest} = useGetWorkshopInterestQuery({id: props.interestId});

  const vehicleId = workshopInterest?.vehicleId;

  return (
    <Section>
      <Show when={isNotNil(vehicleId)}>
        <OwnershipSection vehicleId={vehicleId ?? ''} isTabsHidden />
      </Show>
      <Show when={!isNotNil(vehicleId)}>
        <EmptyStatus headline={i18n.t('entity.insurance.errors.noVehicleSelected')} />
      </Show>
    </Section>
  );
}
